/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */


import { createViewerRelationshipHook } from '../../core/factories/createViewerRelationshipHook.js';
import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetBlockedAccountCheckRow } from '../openapi-types.gen.js';
import { type useGetBlockedAccountCheckArgs, useGetBlockedAccountCheckSpec } from '../specs/blocked-accounts.spec.gen.js';

export type { GetBlockedAccountCheckRow } from '../openapi-types.gen.js';
export type { useGetBlockedAccountCheckArgs } from '../specs/blocked-accounts.spec.gen.js';


export const useGetBlockedAccountCheck = createViewerRelationshipHook(useGetBlockedAccountCheckSpec);


/**
 * Hover/intent prefetch companion for `useGetBlockedAccountCheck`. Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * and writes the response into the SAME cache entry the reader hook
 * observes. The component owning the callback does NOT subscribe — no
 * re-renders on data, no NATS subscription. Idempotent: TanStack
 * `prefetchQuery` is a no-op when a fresh cache entry already exists.
 *
 *     function Link({ pubkey }) {
 *       const prefetch = usePrefetchGetBlockedAccountCheck();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({ pubkey })}
 *           onFocus={() => prefetch({ pubkey })}
 *         >…</a>
 *       );
 *     }
 */
export const usePrefetchGetBlockedAccountCheck = createPrefetchHook(useGetBlockedAccountCheckSpec);
